import React from 'react';
import { BasicPredictionsTab } from '../BasicPredictionsTab';

export interface PredictionsProps {
  dotNumber: number;
}

const Predictions: React.FC<PredictionsProps> = ({ dotNumber }) => {
  return <BasicPredictionsTab dotNumber={dotNumber} />;
};

export default Predictions;
